import { ComplexEnumItem } from '../../utils/complexEnum/ComplexEnumItem'

export class EJReportTypeItem<
  ID extends Lowercase<string>,
  ClassType extends string | undefined,
  Label extends string | undefined
> extends ComplexEnumItem<ID> {
  /**
   * the classType used to reference the record on the server
   */
  readonly classType: ClassType
  /**
   * the "human readable" name associated with {@link classType}
   */
  readonly type: string
  /**
   * the property of the associated {@link classType} used to get the label associated
   * with a specific instance
   */
  readonly label: Label
  constructor({
    id,
    classType,
    label,
    type,
  }: Pick<
    EJReportTypeItem<ID, ClassType, Label>,
    'id' | 'classType' | 'label' | 'type'
  > &
    Partial<EJReportTypeItem<ID, ClassType, Label>>) {
    super(id)
    this.classType = classType
    this.label = label
    this.type = type
  }
}
